var hash = require('../hash');
var utils = hash.utils;
var assert = utils.assert;

var rotr32 = utils.rotr32;
var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var Num64 = utils.Num64;
var BlockHash = hash.common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

var sha512_K = [
  [ 0x428a2f98, 0xd728ae22], [ 0x71374491, 0x23ef65cd ],
  [ 0xb5c0fbcf, 0xec4d3b2f], [ 0xe9b5dba5, 0x8189dbbc ],
  [ 0x3956c25b, 0xf348b538], [ 0x59f111f1, 0xb605d019 ],
  [ 0x923f82a4, 0xaf194f9b], [ 0xab1c5ed5, 0xda6d8118 ],
  [ 0xd807aa98, 0xa3030242], [ 0x12835b01, 0x45706fbe ],
  [ 0x243185be, 0x4ee4b28c], [ 0x550c7dc3, 0xd5ffb4e2 ],
  [ 0x72be5d74, 0xf27b896f], [ 0x80deb1fe, 0x3b1696b1 ],
  [ 0x9bdc06a7, 0x25c71235], [ 0xc19bf174, 0xcf692694 ],
  [ 0xe49b69c1, 0x9ef14ad2], [ 0xefbe4786, 0x384f25e3 ],
  [ 0x0fc19dc6, 0x8b8cd5b5], [ 0x240ca1cc, 0x77ac9c65 ],
  [ 0x2de92c6f, 0x592b0275], [ 0x4a7484aa, 0x6ea6e483 ],
  [ 0x5cb0a9dc, 0xbd41fbd4], [ 0x76f988da, 0x831153b5 ],
  [ 0x983e5152, 0xee66dfab], [ 0xa831c66d, 0x2db43210 ],
  [ 0xb00327c8, 0x98fb213f], [ 0xbf597fc7, 0xbeef0ee4 ],
  [ 0xc6e00bf3, 0x3da88fc2], [ 0xd5a79147, 0x930aa725 ],
  [ 0x06ca6351, 0xe003826f], [ 0x14292967, 0x0a0e6e70 ],
  [ 0x27b70a85, 0x46d22ffc], [ 0x2e1b2138, 0x5c26c926 ],
  [ 0x4d2c6dfc, 0x5ac42aed], [ 0x53380d13, 0x9d95b3df ],
  [ 0x650a7354, 0x8baf63de], [ 0x766a0abb, 0x3c77b2a8 ],
  [ 0x81c2c92e, 0x47edaee6], [ 0x92722c85, 0x1482353b ],
  [ 0xa2bfe8a1, 0x4cf10364], [ 0xa81a664b, 0xbc423001 ],
  [ 0xc24b8b70, 0xd0f89791], [ 0xc76c51a3, 0x0654be30 ],
  [ 0xd192e819, 0xd6ef5218], [ 0xd6990624, 0x5565a910 ],
  [ 0xf40e3585, 0x5771202a], [ 0x106aa070, 0x32bbd1b8 ],
  [ 0x19a4c116, 0xb8d2d0c8], [ 0x1e376c08, 0x5141ab53 ],
  [ 0x2748774c, 0xdf8eeb99], [ 0x34b0bcb5, 0xe19b48a8 ],
  [ 0x391c0cb3, 0xc5c95a63], [ 0x4ed8aa4a, 0xe3418acb ],
  [ 0x5b9cca4f, 0x7763e373], [ 0x682e6ff3, 0xd6b2b8a3 ],
  [ 0x748f82ee, 0x5defb2fc], [ 0x78a5636f, 0x43172f60 ],
  [ 0x84c87814, 0xa1f0ab72], [ 0x8cc70208, 0x1a6439ec ],
  [ 0x90befffa, 0x23631e28], [ 0xa4506ceb, 0xde82bde9 ],
  [ 0xbef9a3f7, 0xb2c67915], [ 0xc67178f2, 0xe372532b ],
  [ 0xca273ece, 0xea26619c], [ 0xd186b8c7, 0x21c0c207 ],
  [ 0xeada7dd6, 0xcde0eb1e], [ 0xf57d4f7f, 0xee6ed178 ],
  [ 0x06f067aa, 0x72176fba], [ 0x0a637dc5, 0xa2c898a6 ],
  [ 0x113f9804, 0xbef90dae], [ 0x1b710b35, 0x131c471b ],
  [ 0x28db77f5, 0x23047d84], [ 0x32caab7b, 0x40c72493 ],
  [ 0x3c9ebe0a, 0x15c9bebc], [ 0x431d67c4, 0x9c100d4c ],
  [ 0x4cc5d4be, 0xcb3e42b6], [ 0x597f299c, 0xfc657e2a ],
  [ 0x5fcb6fab, 0x3ad6faec], [ 0x6c44198c, 0x4a475817 ]
];
sha512_K = sha512_K.map(function(pair) {
  return new Num64(pair[0], pair[1]);
});

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [ 0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
             0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19 ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
exports.sha256 = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [ 0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
             0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
exports.sha224 = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [ new Num64(0x6a09e667, 0xf3bcc908),
             new Num64(0xbb67ae85, 0x84caa73b),
             new Num64(0x3c6ef372, 0xfe94f82b),
             new Num64(0xa54ff53a, 0x5f1d36f1),
             new Num64(0x510e527f, 0xade682d1),
             new Num64(0x9b05688c, 0x2b3e6c1f),
             new Num64(0x1f83d9ab, 0xfb41bd6b),
             new Num64(0x5be0cd19, 0x137e2179) ];
  this.k = sha512_K;
  this.W = new Array(80);
}
utils.inherits(SHA512, BlockHash);
exports.sha512 = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._update = function _update(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 16; i++)
    W[i] = new Num64(msg[start + 2 * i], msg[start + 2 * i + 1]);
  for (; i < W.length; i++)
    W[i] = g1_512(W[i - 2]).sum3(W[i - 7], g0_512(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i++) {
    var T1 = h.sum4(s1_512(e), ch64(e, f, g), this.k[i], W[i]);
    var T2 = s0_512(a).sum(maj64(a, b, c));
    h = g;
    g = f;
    f = e;
    e = d.sum(T1);
    d = c;
    c = b;
    b = a;
    a = T1.sum(T2);
  }

  this.h[0].isum(a);
  this.h[1].isum(b);
  this.h[2].isum(c);
  this.h[3].isum(d);
  this.h[4].isum(e);
  this.h[5].isum(f);
  this.h[6].isum(g);
  this.h[7].isum(h);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex64(this.h, 'big');
  else
    return utils.split64(this.h, 'big');
};

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [ new Num64(0xcbbb9d5d, 0xc1059ed8),
             new Num64(0x629a292a, 0x367cd507),
             new Num64(0x9159015a, 0x3070dd17),
             new Num64(0x152fecd8, 0xf70e5939),
             new Num64(0x67332667, 0xffc00b31),
             new Num64(0x8eb44a87, 0x68581511),
             new Num64(0xdb0c2e0d, 0x64f98fa7),
             new Num64(0x47b5481d, 0xbefa4fa4) ];
}
utils.inherits(SHA384, SHA512);
exports.sha384 = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex64(this.h.slice(0, 6), 'big');
  else
    return utils.split64(this.h.slice(0, 6), 'big');
};

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe,
             0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
exports.sha1 = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (var i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}

function p32(x, y, z) {
  return x ^ y ^ z;
}

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}

function ch64(x, y, z) {
  return new Num64(
    (x.hi & y.hi) ^ ((~x.hi) & z.hi),
    (x.lo & y.lo) ^ ((~x.lo) & z.lo)
  );
}

function maj64(x, y, z) {
  return new Num64(
    (x.hi & y.hi) ^ (x.hi & z.hi) ^ (y.hi & z.hi),
    (x.lo & y.lo) ^ (x.lo & z.lo) ^ (y.lo & z.lo)
  );
}

function s0_512(x, y, z) {
  return x.rotr(28).xor2(x.rotr(34), x.rotr(39));
}

function s1_512(x, y, z) {
  return x.rotr(14).xor2(x.rotr(18), x.rotr(41));
}

function g0_512(x, y, z) {
  return x.rotr(1).xor2(x.rotr(8), x.shr(7));
}

function g1_512(x, y, z) {
  return x.rotr(19).xor2(x.rotr(61), x.shr(6));
}
